import React, {useEffect, useState} from 'react'
import styled from "styled-components";
import {PageWrap} from "../../Components";
import {REPO} from "../../Repository/repo";
import {BoardItemModel} from "../../Model/BoardModel";
import {DocumentListModel} from "../../Model/DocumentModel";
import {VacationApprovalRow} from "../../Model/VacationModel";
import {DocumentList, NoticeList} from "../../Containers/MainTable/MainTable";
import VacationMini from "../../Containers/MainTable/VacationMini";
import VacationApprovalMini from "../../Containers/MainTable/VacationApprovalMini";
import useUser from "../../Hooks/useUser";

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

const MainPage = () => {
    const { userData } = useUser()
    const isHeadquarters = !!userData?.data?.is_headquarters
    const [notice, setNotice] = useState<BoardItemModel[]>([])
    const [document, setDocument] = useState<DocumentListModel[]>([])
    const [vacationApproval, setVacationApproval] = useState<VacationApprovalRow[]>([])

    useEffect(()=>{
        fetchMethod()
    },[])

    const fetchMethod = async () => {
        try {
            const result = await REPO.System.Main()
            setNotice(result.data.notice)
            setDocument(result.data.document)
            setVacationApproval(result.data.vacation_approval || [])
        } catch (e) {

        }
    }

    return(
        <PageWrap>
            {isHeadquarters ? (
                <Row>
                    <div>
                        <h3>공지사항</h3>
                        <NoticeList data={notice}/>
                    </div>
                    <div>
                        <h3>휴가 캘린더</h3>
                        <VacationMini/>
                    </div>
                </Row>
            ) : (
                <>
                    <h3>공지사항</h3>
                    <NoticeList data={notice}/>
                </>
            )}
            <h3>전자결재 목록</h3>
            <DocumentList data={document}/>
            <h3 style={{marginTop: 24}}>휴가결재 목록</h3>
            <VacationApprovalMini data={vacationApproval}/>
        </PageWrap>
    )
}

export default MainPage
